import axios from "axios"
import Swal from "sweetalert2";
import moment from 'moment';

document.querySelector('#pgoPendingRequest') && new Vue({
    el: '#pgoPendingRequest',
    data: function () {
        return {
            gas_slip: null,
            no_of_liters: gasRequestJson?.no_of_liters,
            remarks: gasRequestJson?.remarks,
            date_of_request: gasRequestJson?.date_of_request,
            show_date_input: false,
            new_date: gasRequestJson?.date_of_request,
        };
    },
    computed: {
        gasRequest() {
            return gasRequestJson && gasRequestJson;
        },
        dateOfRequestFormatted() {
            if (this.date_of_request == null) {
                return '';
            }

            return moment(this.date_of_request).format('LL');
        }
    },
    methods: {
        less(val) {

            Swal.fire({
                title: 'Deduct Value',
                html:
                    '<p>Requested Liters: ' + val + '</p>' +
                    '<p>New Value: <span id="newValue"></span></p>' +
                    '<label style="text-align: left">Percentage: </label>' +
                    '<input id="percentageInput" type="number" class="swal2-input" value="30" style="width: 100%; margin: 12px 0">',
                showCancelButton: true,
                confirmButtonText: 'Apply',
                cancelButtonText: 'Cancel',
                showLoaderOnConfirm: true,
                customClass: {
                    htmlContainer: 'custom-html-container'
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    this.no_of_liters = parseFloat(val - (val * ($('#percentageInput').val() / 100))).toFixed(2)
                }
            });

            $('#newValue').text(parseFloat(val - (val * 0.3)).toFixed(2));

            $('#percentageInput').on('input', function () {

                $('#newValue').text(parseFloat(val - (val * (this.value / 100))).toFixed(2));
            })


        },
        applyLess(val) {
            this.no_of_liters = Math.round(this.gasRequest.no_of_liters - (this.gasRequest.no_of_liters * 0.3));
        },
        applyNewDate() {
            this.date_of_request = this.new_date;
            this.show_date_input = false;
        },
        showDateInput() {
            this.show_date_input = true;
        },
        confirmApprove() {
            console.log(gasRequestJson)
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Approve',
                reverseButtons: true,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        // const gasRequest = gasRequestJson;
                        // gasRequest.no_of_liters = document.getElementById('gas_no_of_liters').value;
                        // gasRequest.remarks = document.getElementById('gas_remarks').value;

                        const gasRequest = {
                            ...gasRequestJson,
                            no_of_liters: this.no_of_liters,
                            date_of_request: moment(this.date_of_request).format('YYYY-MM-DD'),
                            remarks: this.remarks,
                        };

                        await axios.post(`/pgo/pending-requests/${requestId}/approve`, gasRequest);

                        this.gas_slip = `/pgo/gas-slip-request/${requestId}/print`;

                        // Swal.fire(
                        //     'Deleted!',
                        //     'Your file has been deleted.',
                        //     'success'
                        // )
                        $('#gasSlipModal').modal('show');
                    } catch (e) {
                        Swal.fire(
                            'Error!',
                            e.toString(),
                            'error'
                        )
                    }
                }
            })
        },
        print() {
            var prtContent = document.getElementById("gasSlipImg");
            var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint.document.write(prtContent.innerHTML);
            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
        },
        download() {
            var link = document.createElement('a');
            link.href = `/pgo/gas-slip-request/${requestId}/print`;
            link.download = gasSlipNo + '.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async disapprove() {
            const res = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Disapprove',
                input: 'textarea',
                inputLabel: 'Reason',
                reverseButtons: true,
            });

            if (res.value == '' || res.value == undefined) {
                return;
            }

            try {
                await axios.post(`/pgo/pending-requests/${requestId}/disapprove`, {
                    'reason': res.value,
                });

                window.document.location = '/pgo/pending-requests';
            } catch (e) {
                Swal.fire('Error!', e.toString(), 'error');
            }
        },
    },

    mounted() {
        const myModalEl = document.getElementById('gasSlipModal')
        myModalEl.addEventListener('hidden.coreui.modal', event => {
            window.document.location = '/pgo/pending-requests';
        })





    }

})